export class MetricData {
  id?: string;

  metrics_name: string;

  metrics_values: string[];

  options?: string[];

  data?: any[];

  favorite?: boolean;

  isDash?: boolean;

  description?: string;

  complete?: boolean;

  constructor(data: any) {
    this.id = data?.id || '';
    this.metrics_name = data?.metrics_name || '';
    this.metrics_values = data?.metrics_values || [];
    this.options = data?.options || [];
    this.data = data?.data || [];
    this.favorite = data?.favorite || false;
    this.isDash = data?.isDash || false;
    this.description = data?.description || '';
    this.complete = data?.complete || false;
  }

  setId(id: string): void {
    this.id = id;
  }

  setMetricsName(name: string): void {
    this.metrics_name = name;
  }

  setMetricsValues(values: string[]): void {
    this.metrics_values = values;
  }

  setOptions(options: string[]): void {
    this.options = options;
  }

  setData(data: any[]): void {
    this.data = data;
  }

  setFavorite(favorite: boolean): void {
    this.favorite = favorite;
  }

  setIsDash(isDash: boolean): void {
    this.isDash = isDash;
  }

  setDescription(description: string): void {
    this.description = description;
  }

  setComplete(complete: boolean): void {
    this.complete = complete;
  }
}
